import React, { useState } from 'react';
import { motion } from 'framer-motion';
import {
  CurrencyDollarIcon,
  ClockIcon,
  DocumentTextIcon,
  CalendarDaysIcon,
  AcademicCapIcon,
  BriefcaseIcon,
  UserGroupIcon
} from '@heroicons/react/24/outline';

const CourseSettings = () => {
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
      // Afficher notification de succès
    }, 1000);
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="space-y-6"
    >
      <div className="flex items-center justify-between">
        <h2 className="text-xl font-semibold text-slate-900 dark:text-slate-50">Paramètres des cours</h2>
      </div>

      <form onSubmit={handleSubmit} className="space-y-6">
        {/* Types de cours */}
        <div className="bg-slate-100/80 dark:bg-slate-800/40 backdrop-blur-xl rounded-xl p-6 border border-slate-200 dark:border-slate-600">
          <h3 className="text-lg font-medium text-slate-900 dark:text-slate-50 mb-4 flex items-center">
            <AcademicCapIcon className="h-5 w-5 mr-2 text-purple-400" />
            Types de cours
          </h3>

          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-slate-200 dark:divide-slate-700">
              <thead>
                <tr>
                  <th className="py-3 text-left text-xs font-medium text-slate-600 dark:text-slate-400 uppercase tracking-wider">Nom</th>
                  <th className="py-3 text-left text-xs font-medium text-slate-600 dark:text-slate-400 uppercase tracking-wider">Description</th>
                  <th className="py-3 text-left text-xs font-medium text-slate-600 dark:text-slate-400 uppercase tracking-wider">Durée (heures)</th>
                  <th className="py-3 text-left text-xs font-medium text-slate-600 dark:text-slate-400 uppercase tracking-wider">Prix de base</th>
                  <th className="py-3 text-center text-xs font-medium text-slate-600 dark:text-slate-400 uppercase tracking-wider">Actions</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-200 dark:divide-slate-700">
                <tr>
                  <td className="py-3 text-sm text-slate-900 dark:text-slate-50">Développement Web</td>
                  <td className="py-3 text-sm text-slate-900 dark:text-slate-50">Formation complète au développement web moderne</td>
                  <td className="py-3 text-sm text-slate-900 dark:text-slate-50">60</td>
                  <td className="py-3 text-sm text-slate-900 dark:text-slate-50">25 000 DA</td>
                  <td className="py-3 text-sm text-slate-900 dark:text-slate-50 text-center">
                    <div className="flex justify-center space-x-2">
                      <button type="button" className="p-1 bg-slate-100/80 dark:bg-slate-800/40 rounded text-slate-600 dark:text-slate-400 hover:text-slate-900 dark:text-slate-50 hover:bg-slate-100 dark:hover:bg-slate-800/80">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
                          <path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z" />
                        </svg>
                      </button>
                      <button type="button" className="p-1 bg-slate-100/80 dark:bg-slate-800/40 rounded text-slate-600 dark:text-slate-400 hover:text-red-400 hover:bg-slate-100 dark:hover:bg-slate-800/80">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
                          <path fillRule="evenodd" d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z" clipRule="evenodd" />
                        </svg>
                      </button>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td className="py-3 text-sm text-slate-900 dark:text-slate-50">Design Graphique</td>
                  <td className="py-3 text-sm text-slate-900 dark:text-slate-50">Maîtrise des outils et concepts de design graphique</td>
                  <td className="py-3 text-sm text-slate-900 dark:text-slate-50">45</td>
                  <td className="py-3 text-sm text-slate-900 dark:text-slate-50">20 000 DA</td>
                  <td className="py-3 text-sm text-slate-900 dark:text-slate-50 text-center">
                    <div className="flex justify-center space-x-2">
                      <button type="button" className="p-1 bg-slate-100/80 dark:bg-slate-800/40 rounded text-slate-600 dark:text-slate-400 hover:text-slate-900 dark:text-slate-50 hover:bg-slate-100 dark:hover:bg-slate-800/80">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
                          <path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z" />
                        </svg>
                      </button>
                      <button type="button" className="p-1 bg-slate-100/80 dark:bg-slate-800/40 rounded text-slate-600 dark:text-slate-400 hover:text-red-400 hover:bg-slate-100 dark:hover:bg-slate-800/80">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
                          <path fillRule="evenodd" d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z" clipRule="evenodd" />
                        </svg>
                      </button>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td className="py-3 text-sm text-slate-900 dark:text-slate-50">Administration Système</td>
                  <td className="py-3 text-sm text-slate-900 dark:text-slate-50">Administration et sécurité des systèmes Linux</td>
                  <td className="py-3 text-sm text-slate-900 dark:text-slate-50">80</td>
                  <td className="py-3 text-sm text-slate-900 dark:text-slate-50">30 000 DA</td>
                  <td className="py-3 text-sm text-slate-900 dark:text-slate-50 text-center">
                    <div className="flex justify-center space-x-2">
                      <button type="button" className="p-1 bg-slate-100/80 dark:bg-slate-800/40 rounded text-slate-600 dark:text-slate-400 hover:text-slate-900 dark:text-slate-50 hover:bg-slate-100 dark:hover:bg-slate-800/80">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
                          <path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z" />
                        </svg>
                      </button>
                      <button type="button" className="p-1 bg-slate-100/80 dark:bg-slate-800/40 rounded text-slate-600 dark:text-slate-400 hover:text-red-400 hover:bg-slate-100 dark:hover:bg-slate-800/80">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
                          <path fillRule="evenodd" d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z" clipRule="evenodd" />
                        </svg>
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div className="mt-4">
            <button
              type="button"
              className="flex items-center space-x-2 px-4 py-2 bg-slate-100/80 dark:bg-slate-800/40 hover:bg-slate-100 dark:hover:bg-slate-800/80 rounded-lg text-slate-600 dark:text-slate-400 hover:text-slate-900 dark:text-slate-50 transition-colors"
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z" clipRule="evenodd" />
              </svg>
              <span>Ajouter un type de cours</span>
            </button>
          </div>
        </div>

        {/* Spécialités */}
        <div className="bg-slate-100/80 dark:bg-slate-800/40 backdrop-blur-xl rounded-xl p-6 border border-slate-200 dark:border-slate-600">
          <h3 className="text-lg font-medium text-slate-900 dark:text-slate-50 mb-4 flex items-center">
            <BriefcaseIcon className="h-5 w-5 mr-2 text-blue-400" />
            Spécialités
          </h3>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
            <div className="bg-slate-100/80 dark:bg-slate-800/40 p-3 rounded-lg flex justify-between items-center">
              <span className="text-slate-900 dark:text-slate-50">Développement Web</span>
              <button type="button" className="text-slate-600 dark:text-slate-400 hover:text-red-400">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                </svg>
              </button>
            </div>
            <div className="bg-slate-100/80 dark:bg-slate-800/40 p-3 rounded-lg flex justify-between items-center">
              <span className="text-slate-900 dark:text-slate-50">Design Graphique</span>
              <button type="button" className="text-slate-600 dark:text-slate-400 hover:text-red-400">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                </svg>
              </button>
            </div>
            <div className="bg-slate-100/80 dark:bg-slate-800/40 p-3 rounded-lg flex justify-between items-center">
              <span className="text-slate-900 dark:text-slate-50">Administration Système</span>
              <button type="button" className="text-slate-600 dark:text-slate-400 hover:text-red-400">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                </svg>
              </button>
            </div>
            <div className="bg-slate-100/80 dark:bg-slate-800/40 p-3 rounded-lg flex justify-between items-center">
              <span className="text-slate-900 dark:text-slate-50">Réseau et Sécurité</span>
              <button type="button" className="text-slate-600 dark:text-slate-400 hover:text-red-400">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                </svg>
              </button>
            </div>
            <div className="bg-slate-100/80 dark:bg-slate-800/40 p-3 rounded-lg flex justify-between items-center">
              <span className="text-slate-900 dark:text-slate-50">Base de Données</span>
              <button type="button" className="text-slate-600 dark:text-slate-400 hover:text-red-400">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                </svg>
              </button>
            </div>
          </div>

          <div className="mt-4 flex items-center">
            <input
              type="text"
              placeholder="Nouvelle spécialité..."
              className="flex-grow bg-slate-100/80 dark:bg-slate-800/40 border border-slate-200 dark:border-slate-600 rounded-l-lg px-4 py-2 text-slate-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-purple-500"
            />
            <button
              type="button"
              className="px-4 py-2 bg-purple-500/80 hover:bg-purple-500 rounded-r-lg text-slate-900 dark:text-slate-50 transition-colors"
            >
              Ajouter
            </button>
          </div>
        </div>

        {/* Paramètres de génération des certificats */}
        <div className="bg-slate-100/80 dark:bg-slate-800/40 backdrop-blur-xl rounded-xl p-6 border border-slate-200 dark:border-slate-600">
          <h3 className="text-lg font-medium text-slate-900 dark:text-slate-50 mb-4 flex items-center">
            <DocumentTextIcon className="h-5 w-5 mr-2 text-green-400" />
            Certificats
          </h3>
          
          <div className="space-y-4">
            <div>
              <label className="block text-slate-600 dark:text-slate-400 text-sm font-medium mb-2">Texte du certificat</label>
              <textarea
                rows="4"
                className="w-full bg-slate-100/80 dark:bg-slate-800/40 border border-slate-200 dark:border-slate-600 rounded-lg px-4 py-2.5 text-slate-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-purple-500"
                defaultValue="Nous certifions que [NOM_ETUDIANT] a suivi avec succès la formation [NOM_FORMATION] d'une durée de [DUREE_FORMATION] heures, dispensée du [DATE_DEBUT] au [DATE_FIN]. Cette attestation est délivrée pour servir et valoir ce que de droit."
              ></textarea>
              <p className="mt-1 text-sm text-slate-500 dark:text-slate-400">Utilisez les variables entre crochets pour personnaliser le texte.</p>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-slate-600 dark:text-slate-400 text-sm font-medium mb-2">Signature du directeur</label>
                <div className="flex items-center">
                  <input 
                    type="file" 
                    className="hidden" 
                    id="signature-upload" 
                  />
                  <label 
                    htmlFor="signature-upload"
                    className="flex items-center justify-center w-full bg-slate-100/80 dark:bg-slate-800/40 border border-dashed border-slate-200 dark:border-slate-600 rounded-lg p-4 cursor-pointer hover:bg-slate-100 dark:hover:bg-slate-800/80 transition-colors"
                  >
                    <div className="text-center">
                      <svg xmlns="http://www.w3.org/2000/svg" className="mx-auto h-8 w-8 text-slate-400 dark:text-slate-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
                      </svg>
                      <p className="mt-1 text-sm text-slate-600 dark:text-slate-400">Cliquez pour télécharger une image</p>
                    </div>
                  </label>
                </div>
              </div>
              <div>
                <label className="block text-slate-600 dark:text-slate-400 text-sm font-medium mb-2">Logo de l'école</label>
                <div className="flex items-center">
                  <input 
                    type="file" 
                    className="hidden" 
                    id="logo-upload" 
                  />
                  <label 
                    htmlFor="logo-upload"
                    className="flex items-center justify-center w-full bg-slate-100/80 dark:bg-slate-800/40 border border-dashed border-slate-200 dark:border-slate-600 rounded-lg p-4 cursor-pointer hover:bg-slate-100 dark:hover:bg-slate-800/80 transition-colors"
                  >
                    <div className="text-center">
                      <svg xmlns="http://www.w3.org/2000/svg" className="mx-auto h-8 w-8 text-slate-400 dark:text-slate-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
                      </svg>
                      <p className="mt-1 text-sm text-slate-600 dark:text-slate-400">Cliquez pour télécharger une image</p>
                    </div>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Tarification et paiements */}
        <div className="bg-slate-100/80 dark:bg-slate-800/40 backdrop-blur-xl rounded-xl p-6 border border-slate-200 dark:border-slate-600">
          <h3 className="text-lg font-medium text-slate-900 dark:text-slate-50 mb-4 flex items-center">
            <CurrencyDollarIcon className="h-5 w-5 mr-2 text-yellow-400" />
            Tarification et paiements
          </h3>
          
          <div className="space-y-4">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-slate-600 dark:text-slate-400 text-sm font-medium mb-2">TVA (%)</label>
                <input
                  type="number"
                  min="0"
                  max="100"
                  className="w-full bg-slate-100/80 dark:bg-slate-800/40 border border-slate-200 dark:border-slate-600 rounded-lg px-4 py-2.5 text-slate-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-purple-500"
                  defaultValue="19"
                />
              </div>
              <div>
                <label className="block text-slate-600 dark:text-slate-400 text-sm font-medium mb-2">Devise par défaut</label>
                <select className="w-full bg-slate-100/80 dark:bg-slate-800/40 border border-slate-200 dark:border-slate-600 rounded-lg px-4 py-2.5 text-slate-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-purple-500">
                  <option value="DA">Dinar Algérien (DA)</option>
                  <option value="EUR">Euro (€)</option>
                  <option value="USD">Dollar US ($)</option>
                </select>
              </div>
            </div>
            
            <div>
              <label className="block text-slate-600 dark:text-slate-400 text-sm font-medium mb-2">Méthodes de paiement acceptées</label>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-2">
                <label className="inline-flex items-center">
                  <input 
                    type="checkbox" 
                    className="text-purple-500 focus:ring-purple-500 h-4 w-4 rounded"
                    defaultChecked 
                  />
                  <span className="ml-2 text-slate-900 dark:text-slate-50">Espèces</span>
                </label>
                <label className="inline-flex items-center">
                  <input 
                    type="checkbox" 
                    className="text-purple-500 focus:ring-purple-500 h-4 w-4 rounded"
                    defaultChecked 
                  />
                  <span className="ml-2 text-slate-900 dark:text-slate-50">Carte bancaire</span>
                </label>
                <label className="inline-flex items-center">
                  <input 
                    type="checkbox" 
                    className="text-purple-500 focus:ring-purple-500 h-4 w-4 rounded"
                    defaultChecked 
                  />
                  <span className="ml-2 text-slate-900 dark:text-slate-50">Virement bancaire</span>
                </label>
                <label className="inline-flex items-center">
                  <input 
                    type="checkbox" 
                    className="text-purple-500 focus:ring-purple-500 h-4 w-4 rounded"
                    defaultChecked 
                  />
                  <span className="ml-2 text-slate-900 dark:text-slate-50">Chèque</span>
                </label>
                <label className="inline-flex items-center">
                  <input 
                    type="checkbox" 
                    className="text-purple-500 focus:ring-purple-500 h-4 w-4 rounded" 
                  />
                  <span className="ml-2 text-slate-900 dark:text-slate-50">Paiement en ligne</span>
                </label>
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-slate-600 dark:text-slate-400 text-sm font-medium mb-2">Options de paiement échelonné</label>
                <div className="space-y-2">
                  <label className="inline-flex items-center">
                    <input 
                      type="checkbox" 
                      className="text-purple-500 focus:ring-purple-500 h-4 w-4 rounded"
                      defaultChecked 
                    />
                    <span className="ml-2 text-slate-900 dark:text-slate-50">Permettre le paiement en 2 fois</span>
                  </label>
                  <label className="inline-flex items-center">
                    <input 
                      type="checkbox" 
                      className="text-purple-500 focus:ring-purple-500 h-4 w-4 rounded"
                      defaultChecked 
                    />
                    <span className="ml-2 text-slate-900 dark:text-slate-50">Permettre le paiement en 3 fois</span>
                  </label>
                  <label className="inline-flex items-center">
                    <input 
                      type="checkbox" 
                      className="text-purple-500 focus:ring-purple-500 h-4 w-4 rounded"
                      defaultChecked 
                    />
                    <span className="ml-2 text-slate-900 dark:text-slate-50">Permettre le paiement en 4 fois</span>
                  </label>
                  <label className="inline-flex items-center">
                    <input 
                      type="checkbox" 
                      className="text-purple-500 focus:ring-purple-500 h-4 w-4 rounded" 
                    />
                    <span className="ml-2 text-slate-900 dark:text-slate-50">Permettre le paiement en 5 fois</span>
                  </label>
                </div>
              </div>
              <div>
                <label className="block text-slate-600 dark:text-slate-400 text-sm font-medium mb-2">Frais de gestion pour paiement échelonné (%)</label>
                <input
                  type="number"
                  min="0"
                  max="100"
                  step="0.5"
                  className="w-full bg-slate-100/80 dark:bg-slate-800/40 border border-slate-200 dark:border-slate-600 rounded-lg px-4 py-2.5 text-slate-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-purple-500"
                  defaultValue="0"
                />
                <p className="mt-1 text-sm text-slate-500 dark:text-slate-400">Entrez 0 pour aucun frais supplémentaire</p>
              </div>
            </div>
          </div>
        </div>

        <div className="flex justify-end space-x-4">
          <button
            type="button"
            className="px-4 py-2 bg-slate-100/80 dark:bg-slate-800/40 hover:bg-slate-100 dark:hover:bg-slate-800/80 transition-colors rounded-lg text-slate-600 dark:text-slate-400 hover:text-slate-900 dark:text-slate-50"
          >
            Annuler
          </button>
          <button
            type="submit"
            disabled={isLoading}
            className="px-4 py-2 bg-gradient-to-r from-purple-500 to-blue-500 rounded-lg text-white font-medium shadow hover:from-purple-600 hover:to-blue-600 transition-all duration-200 disabled:opacity-50 flex items-center"
          >
            {isLoading ? (
              <>
                <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-slate-900 dark:text-slate-50" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                Enregistrement...
              </>
            ) : 'Enregistrer les modifications'}
          </button>
        </div>
      </form>
    </motion.div>
  );
};

export default CourseSettings;